module.exports = __webpack_public_path__ + "static/bdash-logistics-scheduling-story-thumbnail-cd6a73aff356a59b77f18b4f3a4de1d1.png";